import './HTMLWrapper.css'

export function CustomWrapperComponent({
  dangerouslySetInnerHTML,
}: {
  dangerouslySetInnerHTML?: { __html: string | TrustedHTML }
}) {
  return (
    <div className="custom-wrapper">
      <div dangerouslySetInnerHTML={dangerouslySetInnerHTML} />
    </div>
  )
}
